import { render } from "./ProjectLinks.vue?vue&type=template&id=00ef84fa"
import script from "./ProjectLinks.vue?vue&type=script&lang=js"
export * from "./ProjectLinks.vue?vue&type=script&lang=js"

import "./ProjectLinks.vue?vue&type=style&index=0&id=00ef84fa&lang=css"

import exportComponent from "/Users/brian/Documents/web-projects/clients/andy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__